/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClusterAccountSchema
 */
export interface ClusterAccountSchema {
    /**
     * 
     * @type {string}
     * @memberof ClusterAccountSchema
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterAccountSchema
     */
    name: string;
}

/**
 * Check if a given object implements the ClusterAccountSchema interface.
 */
export function instanceOfClusterAccountSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ClusterAccountSchemaFromJSON(json: any): ClusterAccountSchema {
    return ClusterAccountSchemaFromJSONTyped(json, false);
}

export function ClusterAccountSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterAccountSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'name': json['name'],
    };
}

export function ClusterAccountSchemaToJSON(value?: ClusterAccountSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'slug': value.slug,
        'name': value.name,
    };
}

